export default class GridColumn {
    constructor(id,title, key, width, enabled, isFixed, cellColorProp, rowColorProp, readOnly= false, isRemovable) {

        this.id = id;
        this.title = title;
        this.key = key;
        this.width = width;
        this.cellColorProp = cellColorProp;
        this.rowColorProp = rowColorProp;
        this.readOnly = readOnly;
        this.isFixed = isFixed;
        this.enabled = enabled;
        this.isRemovable = isRemovable

    }
}
